import React from 'react';

import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';

import './PopUp.less';

function FooterActions({children}) {
  return (
    <div className="row">
      <div className="buttondiv">{children}</div>
    </div>
  );
}

FooterActions.propTypes = {
  children: PropTypes.node.isRequired,
};

export function StandalonePopUp({
  isPopUpVisible,
  contents,
  onClose,
  hideCloseButton,
  dialogClassName,
  headerClassName,
  footerClassName,
  id,
}) {
  const {popUpTitle, popUpBody, popUpFooter} = contents;

  return (
    <Modal
      show={isPopUpVisible}
      id={`popup${id ? `-${id}` : ''}`}
      dialogClassName={`modal-dialog-popUp ${dialogClassName}`}
      bsSize="large"
      className="disableTextSelect center popUpPosition"
    >
      <Modal.Header className={!headerClassName ? 'modal-header-popup ' : headerClassName}>
        <Modal.Title className="popupTitle">
          <div className="col-md-11 col-xs-11 col-lg-11 col-xl-11 no-padding">{popUpTitle}</div>
          {(!hideCloseButton || hideCloseButton === false) && (
            <div className="col-md-1 col-xs-1 col-lg-1 col-xl-1 no-padding">
              <button
                type="button"
                onClick={onClose}
                className="popUpClose "
              >
                x
              </button>
            </div>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{popUpBody}</Modal.Body>
      <Modal.Footer className={!footerClassName ? 'modal-footer-popup' : footerClassName}>{popUpFooter}</Modal.Footer>
    </Modal>
  );
}

StandalonePopUp.propTypes = {
  onClose: PropTypes.func,
  isPopUpVisible: PropTypes.bool,
  contents: PropTypes.object,
  hideCloseButton: PropTypes.bool,
  dialogClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  id: PropTypes.string,
};

StandalonePopUp.defaultProps = {
  onClose: () => {},
  isPopUpVisible: false,
  hideCloseButton: false,
  contents: {},
  dialogClassName: '',
  headerClassName: '',
  footerClassName: '',
  id: '',
};

StandalonePopUp.FooterActions = FooterActions;

export default StandalonePopUp;
